'use client';

import { useEffect } from 'react';
import Shading from 'app/components/common/Shading';
import ImageBg from './components/common/ImageBg';
import { defaultProcessText } from 'app/utility/textProcessing';
import { errorData } from '@/data';
import { LogItemStatus } from 'app/utility/validation';
import {
  isChunkLoadError,
  reloadOnceForChunkError
} from 'app/utility/chunkError';

export default function Error({
  error
}: {
  error: Error & { digest?: string };
  unstable_retry: () => void;
}) {
  useEffect(() => {
    if (!error) return;

    // Устаревший деплой: старый HTML тянет несуществующий чанк.
    // Перезагружаемся за свежим HTML вместо показа 500 и не засоряем лог.
    if (isChunkLoadError(error) && reloadOnceForChunkError()) return;

    try {
      void fetch('/api/log', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          status: LogItemStatus.Error,
          message: `Ошибка: ${error?.message || 'Неизвестная ошибка'} в ${window.location.href}<br><br>Stack: ${error?.stack || ''}`
        })
      });
    } catch {}
  }, [error]);
  return (
    <main className="bg-sand">
      <section className="wrapper-main wrapper-max min-h-screen flex flex-col justify-center gap-10 md:gap-4 xl:gap-0">
        <div className="uppercase text-line text-brown z-10">
          <h1>500</h1>
        </div>
        <div className="md:flex xl:flex-row-reverse justify-between items-start w-full">
          <div className="flex flex-col justify-between items-center gap-10 md:gap-15 w-full md:max-w-100 xl:max-w-[580px]">
            <div
              className="text-xl xl:text-3xl text-balance"
              dangerouslySetInnerHTML={{
                __html: defaultProcessText(errorData?.title)
              }}
            />
          </div>
          <div className="relative hidden md:block md:rounded overflow-hidden w-58 group">
            <ImageBg
              src={errorData.image.url}
              width={1496}
              height={998}
              alt="404"
              className="object-cover w-full min-h-full group-hover:scale-105 transition-transform group-hover:duration-700 duration-700"
            />
            <Shading className="group-hover:bg-black-20 transition-transform group-hover:duration-700 duration-700" />
          </div>
        </div>
      </section>
    </main>
  );
}
